import React from "react";
import { Progress, Typography } from "antd";
import { formatData } from "@shared/lib/utils/formatData";

const { Text } = Typography;

interface Props {
  items: { name: string; value: number }[];
  isNew?: boolean;
}
const StatsItem: React.FC<Props> = ({ items, isNew }) => {
  return (
    <section style={{ maxHeight: "220px", overflowY: "auto", marginTop: 20 }}>
      {items.map((item, idx) => {
        return (
          <div key={idx}>
            <Text type="secondary" strong>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <span>{item.name}</span>
                <span>
                  {isNew
                    ? item?.value.toFixed(2) || 0
                    : formatData(item?.value || 0, "0.00")}
                  %
                </span>
              </div>
            </Text>
            <Progress
              percent={item.value}
              status="active"
              strokeColor={"#2130FF"}
              showInfo={false}
            />
          </div>
        );
      })}
    </section>
  );
};

export default StatsItem;
